import type { AttachmentMode } from '../hooks/useClaimAttachments'

/* global Office */

export function isComposeMode(): boolean {
  try {
    const item = Office?.context?.mailbox?.item
    if (!item) return false
    return typeof item.subject !== 'string'
  } catch {
    return false
  }
}

export function getHasEmailAttachments(mode: AttachmentMode): boolean {
  if (mode !== 'save') return true
  try {
    const item = Office?.context?.mailbox?.item
    if (!item) return true
    return ((item as Office.MessageRead).attachments ?? []).length > 0
  } catch {
    return true
  }
}
